import * as React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import { Modal } from 'lib/components';
import { MdDeleteForever } from 'react-icons/md';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';
interface Props {
  onClose: (params?: any) => void;
  onDelete: (params?: any) => void;
  // data: ListWebsiteOverlay;
}

interface RowProps {
  justifyContent?: string;
  maxWidth?: string;
}

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
`;

const Row = styled.section<RowProps>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'flex-start'};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
  margin-bottom: 16px;
  &:last-of-type {
    margin-bottom: 0;
  }
  button {
    margin-left: 12px;
  }
`;

const Title = styled.h2`
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 18px;
  color: ${theme.palette.coal};
`;

const CloseIconWrap = styled.div`
  display: flex;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const ModalExitLandingPageBuilder = (props: Props) => {
  const { onClose, onDelete } = props;
  return (
    <Modal>
      <Content>
        <Row justifyContent={'space-between'}>
          <Title>Exit Landing Page Builder?</Title>
          <CloseIconWrap>
            <IoMdClose
              size={24}
              onClick={onClose}
              color={theme.palette.midGrey}
            />
          </CloseIconWrap>
        </Row>
        <Row justifyContent={'flex-end'}>
          <Button
            variant='destructive'
            icon={<MdDeleteForever />}
            text={'Leave this Page'}
            onClick={() => onDelete()}
          />
          <Button text={'Stay on this Page'} onClick={() => onClose()} />
        </Row>
      </Content>
    </Modal>
  );
};
